"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useClinicianAndPatientModeratorsSearch = void 0;
var _react = require("react");
var _lodash = require("lodash");
var _utils = require("../../utils");
var _constants = require("./constants");
var _util = require("./util");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useClinicianAndPatientModeratorsSearch = function useClinicianAndPatientModeratorsSearch(form, skipClinicianId) {
  var getFieldValue = form.getFieldValue;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var patientModerators = getFieldValue(_constants.PATIENT_MODERATORS_FIELD_NAME);
  var clinicianModerators = getFieldValue(_constants.CLINICIAN_MODERATORS_FIELD_NAME);
  var currentNumOfAdditionalModerators = Number((patientModerators === null || patientModerators === void 0 ? void 0 : patientModerators.length) || 0) + Number((clinicianModerators === null || clinicianModerators === void 0 ? void 0 : clinicianModerators.length) || 0);
  var hasMaxNumberOfModerators = currentNumOfAdditionalModerators === _constants.MAX_MODERATORS_COUNT;
  var onLoadClinicianOptions = (0, _react.useCallback)((0, _lodash.debounce)( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(searchValue, setOptions) {
      var _yield$api$get, clinicians, cliniciansWithoutMainModerator, reactSelectMembers;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              if (!hasMaxNumberOfModerators) {
                _context.next = 4;
                break;
              }
              _utils.toast.error({
                title: "Max number of moderators (".concat(_constants.MAX_MODERATORS_COUNT, ") reached"),
                description: 'Please delete some moderators to select the new ones'
              });
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return _utils.api.get((0, _utils.getSearchCliniciansUrl)({
                query: searchValue
              }));
            case 6:
              _yield$api$get = _context.sent;
              clinicians = _yield$api$get.data;
              cliniciansWithoutMainModerator = clinicians === null || clinicians === void 0 ? void 0 : clinicians.filter(function (clinician) {
                return clinician.id !== skipClinicianId;
              });
              if (!(0, _lodash.isEmpty)(cliniciansWithoutMainModerator)) {
                reactSelectMembers = (0, _util.getReactSelectOptionsFromModerators)(cliniciansWithoutMainModerator);
                setOptions(reactSelectMembers);
              }
              setLoading(false);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), 700), [clinicianModerators, hasMaxNumberOfModerators, loading]);
  var onLoadPatientOptions = (0, _react.useCallback)((0, _lodash.debounce)( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(searchValue, setOptions) {
      var _yield$api$get2, patients, reactSelectMembers;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              if (!hasMaxNumberOfModerators) {
                _context2.next = 4;
                break;
              }
              _utils.toast.error({
                title: "Max number of moderators (".concat(_constants.MAX_MODERATORS_COUNT, ") reached"),
                description: 'Please delete some moderators to select others'
              });
              return _context2.abrupt("return");
            case 4:
              _context2.next = 6;
              return _utils.api.get((0, _utils.getSearchPatientsUrl)({
                query: searchValue
              }));
            case 6:
              _yield$api$get2 = _context2.sent;
              patients = _yield$api$get2.data;
              if (!(0, _lodash.isEmpty)(patients)) {
                reactSelectMembers = (0, _util.getReactSelectOptionsFromModerators)(patients);
                setOptions(reactSelectMembers);
              }
              setLoading(false);
            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), 700), [patientModerators, hasMaxNumberOfModerators, loading]);
  return {
    onLoadClinicianOptions: onLoadClinicianOptions,
    onLoadPatientOptions: onLoadPatientOptions
  };
};
exports.useClinicianAndPatientModeratorsSearch = useClinicianAndPatientModeratorsSearch;